// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestSearchResults-cls1_Ntg","cls2":"ResearchInterestSearchResults-cls2_H84 ResearchInterestSearchResults-cls1_Ntg"};